<template>
  <el-tooltip
    class="gray_tool_tip"
    effect="dark"
    :content="text"
    placement="right"
    :visible-arrow="false"
  >
    <i class="el-icon-warning"></i>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less">
.gray_tool_tip {
  font-size: 14px;
  line-height: 20px;
  max-width: 200px;
  background-color: #808080;
}
</style>
